export default {
    Get: {
        LIST_OF_USERS: 'getListOfUsers',
        LIST_OF_USERS_BY_IDNAME: 'getListOfUserByIdName',
        LIST_OF_USERS_LOOKUP: 'getListOfUsersLookup',
        AUTH_CONFIG: 'getAuthConfig',

        //Api NEW
        USER_INFO: 'getUserInfo',
        USER_CONFIGURATION: 'getUserConfiguration',
        TWO_FACTOR: 'getTwoFactorInfo',
        GENERATE_QR_CODE: 'generateQRCode',
        VERIFY_QR_CODE: 'verifyQRCode',
        USER_NOTIFICATION_CONFIG: 'getUserNotificationConfiguration',
        
        GET_COMPANIES_LIST: 'getCompaniesList',
        USER_PREPARE_REGISTER_ACCOUNT: 'userPrepareRegisterAccount',
        GET_BUSINESS_LIST: 'getBusinessList',
        USER_RIGHTS: 'userRights'
    },
    Set: {
        LIST_OF_USERS: 'setListOfUsers',
        LIST_OF_USERS_BY_IDNAME: 'setListOfUserByIdName',
        AUTH_CONFIG:'setAuthConfig',
        USER_CONFIG:'setUserConfig',
        UPDATE_USER_CONFIG: 'updateUserConfig',
        COPY_AGENDA_CONFIG: 'copyAgendaConfig',

        // API NEW
        USER_INFO: 'setUserInfo',
        USER_INFO_ORIGINAL: 'setUserInfoOriginal',
        USER_INFO_ASSIGN_VALUE: 'assignUserInfoValue',
        UPDATE_USER_INFO: 'updateUserInfo',

        USER_CONFIGURATION: 'setUserConfiguration',
        USER_CONFIGURATION_ORIGINAL: 'setUserConfigurationOriginal',
        UPDATE_USER_CONFIGURATION: 'updateUserConfiguration',
        
        USER_CONFIGURATION_OUTLOOK_SYNC_ASSIGN_VALUE: 'assignUserConfigOutlookSync',
        USER_CONFIGURATION_SYNC_PERSON_INFO_ASSIGN_VALUE: 'assignUserConfigSyncPersonInfo',
        USER_CONFIGURATION_AGENDA_ASSIGN_VALUE: 'assignUserConfigAgenda',
        USER_CONFIGURATION_TASK_AGENDA_ASSIGN_VALUE: 'assignUserConfigTaskAgenda',
        USER_CONFIGURATION_EXCHANGE_CONFIG_ASSIGN_VALUE: 'assignUserConfigExchangeConfig',
        USER_CONFIGURATION_SEE_AGENDA: 'configurationSeeAgenda',

        TWO_FACTOR: 'setTwoFactor',
        TWO_FACTOR_ORIGINAL: 'setTwoFactorOriginal',
        TWO_FACTOR_ASSIGN_VALUE: 'assignTwoFactorConfigValue',
        UPDATE_TWO_FACTOR_CONFIG: 'updateTwoFactor',
        USER_CHANGE_PASSWORD: 'setUserChangingPassword',

        NOTIFICATION_CONFIG: 'setNotificationConfig',
        NOTIFICATION_CONFIG_ORIGINAL: 'setNotificationConfigOriginal',
        NOTIFICATION_CONFIG_APPOINTMENT: 'assignNotitificationConfigAppointment',
        NOTIFICATION_CONFIG_TASK: 'assignNotitificationConfigTask',
        NOTIFICATION_CONFIG_OTHER: 'assignNotitificationConfigOther',
        UPDATE_NOTIFICATION_CONFIG: "updateNOtificationConfig",

        REGISTER_REAL_ESTATE_AGENT: 'registerRealEstateAgent',
        USER_CONFIGURATION_ES: 'userConfigurationES',
        ENABLE_USER_CONFIGURATION_ES: 'enableUserConfigurationES',
        USER_GENERATE_TOKEN: 'userGenerateToken',
        USER_APPLY_REGISTER_ACCOUNT: 'userApplyRegisterAccount',
        SET_BG_COLOR_SUBSTATUS: 'configurationColorSubStatus',
        USER_RIGHTS: 'userRights'
    }
};